import baseService from "@/services/Base-service";

class CartabelService {
   
    get controllerName() { return `/Cartabel/`; }

    getDeleteUrl(itemId) {
        return this.controllerName + 'delete/' + itemId;
    }

    selectRequestsCartabel() {
        return baseService.get(this.controllerName + `selectRequestsCartabel`);
    }

    setStatusRequest(model) {
        return baseService.post(this.controllerName + `SetStatusRequest`, model);
    }

    cartabel_DeleteApplyDateHistory(itemId) {
        return this.controllerName + 'Cartabel_DeleteApplyDateHistory/' + itemId;
    }

}
export default new CartabelService();